import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { Config } from './config'
import { Plugin } from './plugin'

/**
 * {@link ec.plugins.Plugin.Factory} for the canonical table plugin.
 *
 * A factory can receive fixed options or a collection-aware options callback;
 * both forms are normalized by the produced plugin before mapping begins.
 */
export class Factory<TTypeParams extends ec.models.TypeParams.Constraint>
  implements
    ec.plugins.Plugin.Factory<
      TTypeParams,
      typeof Plugin.id,
      Plugin<TTypeParams>
    >
{
  /** @see {@link ec.plugins.Plugin.Factory.id} */
  public readonly id = Plugin.id

  constructor(
    private readonly _options:
      | Readonly<Config.Options<TTypeParams>>
      | ((
          collection: ec.Collection<TTypeParams>,
        ) => Config.Options<TTypeParams>) = {},
  ) {}

  /**
   * Creates one plugin instance for a collection.
   *
   * A callback is evaluated per collection so configuration can use collection
   * metadata without making the table mapper responsible for factory policy.
   */
  public produceFor(
    collection: ec.Collection<TTypeParams>,
  ): Plugin<TTypeParams> {
    return new Plugin({
      collection,
      config:
        typeof this._options === 'function'
          ? this._options(collection)
          : this._options,
    })
  }
}
